import DepartmentsTable from '@/app/departments'
import { ability } from '@/casl/ability'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <DepartmentsTable />
}

export const Route = createFileRoute('/_auth/_withProject/departments')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Birimler')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  component: RouteComponent,
})


